import React, { Component } from 'react';

export default class NoRecordFound extends Component {

    render () {
        return (
            <div className="col-md-12 col-xs-12 col-lg-12">
                <h5 className='text-center'>Nothing to see here...</h5>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/shared/noRecordFound.js